goog.provide('el8.ext.onboarding.baDetailsDialog');

goog.require('el8.ext.ModalDialog');
goog.require('el8.template.ext.onboarding.baDetailsDialog');
goog.require('el8.service.tz');
goog.require('el8.service.urls');


el8.ext.onboarding.baDetailsDialog = (function() {

    var that = new el8.ext.ModalDialog({
        height: 600,
        width: 600,
        modal: true,
        draggable: false,
        contentFn: function() {
            return el8.template.ext.onboarding.baDetailsDialog.content({
                today: el8.service.tz.today().asStringFormat('mmm ddd, yyyy')
            });
        }
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.download-ba-trigger',  function(e) {
            window.open(el8.service.urls.get('printBaAgreement', [el8.ext.onboarding.signupData.getId()]));
        });
    };

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);
        that.getContentElt().scrollTo(0, 0);
        $('.provider-name', that.getContentElt()).text(el8.ext.onboarding.signupData.getFormalName());
    };

    return that;

})();
